'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('../components/ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

var _table_arrow = require('../tables/table_arrow');

var _table_arrow2 = _interopRequireDefault(_table_arrow);

var _table_two = require('../tables/table_two');

var _table_two2 = _interopRequireDefault(_table_two);

var _table_three = require('../tables/table_three');

var _table_three2 = _interopRequireDefault(_table_three);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Paste in prefabricated blocks from src/blocks
var Tables = {
  table_arrow: _table_arrow2.default,
  table_two: _table_two2.default,
  table_three: _table_three2.default
};

var prefabStrategy = function prefabStrategy(change, type) {
  return change.insertBlock(Tables[type]);
};

var TableButton = function TableButton(_ref) {
  var type = _ref.type,
      icon = _ref.icon,
      title = _ref.title,
      value = _ref.value,
      insideList = _ref.insideList,
      onChange = _ref.onChange;
  return _react2.default.createElement(_ToolbarButton2.default, {
    icon: icon,
    title: title,
    text: title,
    onMouseDown: function onMouseDown(e) {
      return onChange(prefabStrategy(value.change(), type));
    },
    active: !insideList
  });
};

TableButton.propTypes = {
  type: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.object.isRequired,
  insideList: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = TableButton;